import { useRef, useState, useEffect } from 'react'
import { callAPI } from '../../../hooks/api'
import { geojsonToWKT } from '@terraformer/wkt'
import { MapProvider, Map, Source, Layer, Marker } from 'react-map-gl/maplibre'
import { isMobile } from 'react-device-detect'

export default function GenerateFloodMaps({
  parcels,
  localAuth,
  latitude,
  longitude,
  makres,
  setFlooddReportData,
}) {
  const [mapLoaded, setMapLoaded] = useState(false)
  const [floodGeoJson, setFloodGeoJson] = useState()
  const mapRef = useRef(0)
  const layerStyle = {
    id: 'Google Satellite Hybrid',
    type: 'raster',
    source: 'google_earth_hybrid',
    layout: { visibility: 'visible' },
  }

  async function fetchFloodData() {
    const multiPolygons = parcels.map((parcel) =>
      geojsonToWKT(parcel.feature.geometry)
    )
    const polygonParts = multiPolygons.map((wkt) =>
      wkt.replace('MULTIPOLYGON (((', '').replace(')))', '').trim()
    )
    const combinedWKT = `MULTIPOLYGON (((${polygonParts.join(')), ((')})))`
    var endpoint = '/get_flood_from_wkt'
    var params = {
      wkt: combinedWKT,
      session_key: localAuth.sessionKey,
    }

    callAPI(endpoint, params).then((res) => {
      if (res.status === 'success') {
        setFloodGeoJson({
          ...res.flood,
          apn: parcels.map((parcel) => parcel.data.apn),
        })
      }
    })
  }

  async function onLoad() {
    setMapLoaded(true)
  }

  useEffect(() => {
    if (mapLoaded && floodGeoJson.features.length > 0) {
      setFlooddReportData(floodGeoJson)
    }
  }, [mapLoaded, floodGeoJson])

  useEffect(() => {
    fetchFloodData()
  }, [])

  return (
    <div className="absolute w-full h-[400px]">
      {floodGeoJson && floodGeoJson.features.length > 0 && (
        <>
          <div className="w-full aspect-[1108/400] overflow-x-hidden">
            <MapProvider>
              <Map
                preserveDrawingBuffer={true}
                ref={mapRef}
                id="floodMap-Report"
                onLoad={onLoad}
                initialViewState={{
                  longitude: longitude,
                  latitude: latitude,
                  zoom: isMobile ? 9 : 10,
                }}
                style={{ height: '100%', width: '100%' }}
              >
                <Source
                  id="google_earth_hybrid"
                  type="raster"
                  tiles={['https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}']}
                  tileSize={256}
                >
                  <Layer {...layerStyle} />
                </Source>
                {floodGeoJson &&
                  floodGeoJson.features.map((feature) => (
                    <Source
                      key={`property-source-${feature.id}`}
                      id={`property-source-${feature.id}`}
                      type="geojson"
                      data={feature}
                    >
                      <Layer
                        {...{
                          source: `property-source-${feature.id}`,
                          id: `property-layer-${feature.id}`,
                          type: 'fill',
                          layout: { visibility: 'visible' },
                          paint: {
                            'fill-color': feature.properties.hex,
                            'fill-opacity': 0.2,
                            'fill-outline-color': feature.properties.hex,
                          },
                        }}
                      />
                      <Layer
                        {...{
                          source: `property-source-${feature.id}`,
                          id: `property-layer-outline-${feature.id}`,
                          type: 'line',
                          layout: {
                            visibility: 'visible',
                            'line-join': 'round',
                            'line-cap': 'round',
                          },
                          paint: {
                            'line-color': feature.properties.hex,
                            'line-width': 4,
                          },
                        }}
                      />
                    </Source>
                  ))}
                {makres &&
                  makres.map((coordinates, index) => {
                    return (
                      <Marker
                        key={`marker-${index}`}
                        longitude={coordinates.lon}
                        latitude={coordinates.lat}
                        color="red"
                      />
                    )
                  })}
              </Map>
            </MapProvider>
          </div>
        </>
      )}
    </div>
  )
}
